let Mailbox = {

    init: function () {

        let count = 0;
        Status.add('gifts', function (data) {
            if (data.count && data.count.gifts != count) {
                if (data.count.gifts == 0)
                    $('#btn-gifts > .count').hide();
                else
                    $('#btn-gifts > .count').html(data.count.gifts).css("display", "block");

                count = data.count.gifts;
            }
        });
    }
}
